import { Navigate, useLocation } from "react-router-dom";

const RequireAuth = ({ children }) => {
  const isAuthenticated = Boolean(
    localStorage.getItem("access_token")
  );
  const location = useLocation();

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location }}
      />
    );
  }

  return children;
};

export default RequireAuth;
